var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import RadioButton from './RadioButton';
import RadioGroup from './RadioGroup';
import RadioGroupContext from './context';
import { ConfigContext } from '../config-provider';
const InternalRadio = (props, ref) => {
    const { prefixCls: customizePrefixCls, children, className, onChange, label } = props, restProps = __rest(props, ["prefixCls", "children", "className", "onChange", "label"]);
    const radioRef = React.createRef();
    const [initChecked, setInitChecked] = useState(false);
    React.useImperativeHandle(ref, () => radioRef.current);
    const context = useContext(RadioGroupContext);
    const radioProps = Object.assign({}, restProps);
    if (context) {
        radioProps.checked = props.value === (context === null || context === void 0 ? void 0 : context.value);
        radioProps.disabled = props.disabled || (context === null || context === void 0 ? void 0 : context.disabled);
    }
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const classes = useMemo(() => {
        // 兼容与antd交互保持一致，引入initChecked判断单独使用时是否选中
        const { disabled, checked } = radioProps;
        const isChecked = checked === !!checked ? checked : initChecked;
        return classNames(prefixCls, {
            [`${prefixCls}-wrapper`]: true,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-checked`]: isChecked
        }, className);
    }, [radioProps, initChecked]);
    const handleClick = useCallback(e => {
        var _a;
        const { value, disabled } = radioProps;
        const wrapClassReg = new RegExp(`${prefixCls}-wrapper`);
        if (disabled || wrapClassReg.test(e.target.className)) {
            return;
        }
        e.target.value = value || true;
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        e.target.value = value;
        (_a = context === null || context === void 0 ? void 0 : context.onChange) === null || _a === void 0 ? void 0 : _a.call(context, e);
        setInitChecked(true);
    }, [radioProps, setInitChecked]);
    return (<span className={classes} ref={radioRef} onClick={handleClick} {...radioProps}>
        <span className={`${prefixCls}-content`}>
            <span className={`${prefixCls}-outline`}>
                <span className={`${prefixCls}-inner`}></span>
            </span>
            <span className={`${prefixCls}-label`}>{children || label}</span>
        </span>
    </span>);
};
const Radio = React.forwardRef(InternalRadio);
Radio.displayName = 'Radio';
Radio.Group = RadioGroup;
Radio.Button = RadioButton;
export default Radio;
